export interface TravelTicketOptionConstructor {
  id: number
  uuid: string
  purpose: string
  status: number
}

export class TravelTicketOption {
  readonly id: number
  readonly uuid: string
  readonly purpose: string
  readonly status: number

  constructor(data: TravelTicketOptionConstructor) {
    this.id = data.id
    this.uuid = data.uuid
    this.purpose = data.purpose || ''
    this.status = data.status
  }

  get displayLabel(): string {
    return `Travel #${this.id} - ${this.purpose}`
  }
}
